import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { comics } from '@/mocks/comics';
import NotFound from '@/pages/NotFound';

export default function ReadPage() {
  const { id } = useParams<{ id: string }>();
  const comic = comics.find((c) => c.id === id);

  if (!comic) {
    return <NotFound />;
  }

  return (
    <Layout>
      <SEOHead
        title={`阅读《${comic.title}》 - 韩漫免费阅读 - 韩漫网站`}
        description={`下拉式阅读《${comic.title}》，作者${comic.author}。韩漫免费阅读，流畅的下拉式浏览体验。`}
        keywords={`${comic.title},韩漫免费阅读,韩国漫画,下拉式韩漫`}
        canonicalUrl={`https://www.hanman.site/comic/${comic.id}/read`}
        ogType="article"
      />

      <Breadcrumb
        items={[
          { label: '首页', to: '/' },
          { label: comic.title, to: `/comic/${comic.id}` },
          { label: '阅读' },
        ]}
      />

      <section className="w-full min-h-[60vh] flex flex-col items-center justify-center py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-book-open-line text-3xl"></i>
          </div>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            《{comic.title}》
          </h1>
          <p className="text-sm text-foreground-500 mb-8">
            下拉式阅读模式即将上线，敬请期待！您可以在下方章节列表中选择想阅读的章节。
          </p>

          <div className="bg-background-100 rounded-lg p-6 text-left mb-8">
            <h2 className="text-sm font-semibold text-foreground-900 mb-4">章节列表</h2>
            <div className="grid grid-cols-1 gap-2">
              {comic.chapters.map((chapter) => (
                <div
                  key={chapter.num}
                  className="flex items-center justify-between p-3 rounded-lg bg-background-50 cursor-pointer hover:bg-primary-50 transition-colors"
                >
                  <span className="text-sm text-foreground-800">{chapter.title}</span>
                  <span className="text-xs text-foreground-400">{chapter.updatedAt}</span>
                </div>
              ))}
            </div>
          </div>

          <Link
            to={`/comic/${comic.id}`}
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i> 返回漫画详情
          </Link>
        </div>
      </section>
    </Layout>
  );
}